import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronCircleLeft, faChevronCircleRight } from '@fortawesome/free-solid-svg-icons';

const CustomNavigation = ({ swiperInstance }) => {
  const [activeBtn, setActiveBtn] = useState('next')
  const handlePrev = () => {
    if (swiperInstance && swiperInstance.swiper) {
      swiperInstance.swiper.slidePrev();
      setActiveBtn('prev')
    }
  };

  const handleNext = () => {
    if (swiperInstance && swiperInstance.swiper) {
      swiperInstance.swiper.slideNext();
      setActiveBtn('next')

    }
  };

  return (
    <div className="custom-navigation d-flex justify-content-between">
      <div className='Customnavleftbutton'>
        <FontAwesomeIcon icon={faChevronCircleLeft} onClick={handlePrev} style={{ fontSize: '39px', cursor: 'pointer', color: activeBtn === 'prev' ? '#F6821F' : '#C1C1C1' }} />
      </div>
      <div className='Customnavrightbutton'>
        <FontAwesomeIcon icon={faChevronCircleRight} onClick={handleNext} style={{ fontSize: '39px', cursor: 'pointer', color: activeBtn === 'next' ? '#F6821F' : '#C1C1C1' }} />

      </div>
    </div>
  );
};

export default CustomNavigation;
